import attachments from './attachments'
import checks from './checks'
import comments from './comments'
import contexts from './contexts'
import dropdown from '@app/shared/vue/store/modules/dropdown'
import notifications from '@app/application/communication/screens/inbox/store/notifications'
import remarks from './remarks'
import ui from './ui'
import users from './users'

export default {
  attachments,
  checks,
  comments,
  contexts,
  dropdown,
  notifications,
  remarks,
  ui,
  users,
}
